import { DeliveryPoint } from '../../../entities/installation-reporting-mdu-details.entities';
import {
  BuildingSectionsResponse,
  DeliveryPointInstallationReportV2Request,
  SectionV2Response,
} from '../model/installation-reporting-mdu-bff.entities';
import { DELIVERY_POINT_REPORT_SECTIONS } from '../model/installation-reporting-mdu-section-layout.config';
import {
  DeliveryPointReportSectionConfig,
  DeliveryPointReportSectionId,
} from '../model/installation-reporting-mdu-section.types';
import {
  emptySectionState,
  mapCommissionStateToRequest,
  mapMeasuringStateToRequest,
  mapPreInstallationStateToRequest,
  mapSectionResponseToSectionState,
} from './installation-reporting-mdu-section-state.mapper';
import { SectionState } from './installation-reporting-mdu-section-state.types';

export type DeliveryPointReportSectionStates = Record<
  DeliveryPointReportSectionId,
  SectionState
>;

export type DeliveryPointSectionsResponse = Pick<
  BuildingSectionsResponse,
  'preInstallation' | 'splicingMeasuring' | 'commissioning'
>;

const completedDateBySection = (
  deliveryPoint: DeliveryPoint,
  sectionId: DeliveryPointReportSectionId,
): string | null | undefined => {
  switch (sectionId) {
    case 'PRE_INSTALLATION':
      return deliveryPoint.preinstallation;
    case 'SPLICING_MEASURING':
      return deliveryPoint.splicingMeasuring;
    case 'COMMISSION':
      return deliveryPoint.commissioning;
  }
};

const initialSection = (
  deliveryPoint: DeliveryPoint,
  sectionId: DeliveryPointReportSectionId,
): SectionV2Response => {
  const value = completedDateBySection(deliveryPoint, sectionId);
  const completedDate =
    value && !Number.isNaN(new Date(value).getTime()) ? value : null;
  return {
    comment: null,
    plannedDate: null,
    completedDate,
    status: completedDate ? 'EXECUTED' : 'PLANNED',
  };
};

export const createDeliveryPointReportSectionStates = (
  deliveryPoint: DeliveryPoint,
  sections: DeliveryPointReportSectionConfig[] = DELIVERY_POINT_REPORT_SECTIONS,
): DeliveryPointReportSectionStates =>
  Object.fromEntries(
    sections.map((section) => {
      const initial = initialSection(deliveryPoint, section.id);
      const current = emptySectionState(section);
      current.status = initial.status;
      return [
        section.id,
        mapSectionResponseToSectionState(section, initial, current),
      ];
    }),
  ) as DeliveryPointReportSectionStates;

export const mapDeliveryPointReportSectionStatesToUpdateRequest = (
  states: DeliveryPointReportSectionStates,
): DeliveryPointInstallationReportV2Request => ({
  preInstallation: mapPreInstallationStateToRequest(states.PRE_INSTALLATION),
  measuring: mapMeasuringStateToRequest(states.SPLICING_MEASURING),
  commission: mapCommissionStateToRequest(states.COMMISSION),
});
